var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApprovedWithoutRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0002 50C38.8073 50 50.0002 38.8071 50.0002 25C50.0002 11.1929 38.8073 0 25.0002 0C11.1931 0 0.000183105 11.1929 0.000183105 25C0.000183105 38.8071 11.1931 50 25.0002 50Z",
    fill: "#26A17B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.0033 27.1615V27.1584C27.8314 27.1709 26.9455 27.224 24.9689 27.224C23.3908 27.224 22.2799 27.1771 21.8892 27.1584V27.1631C15.8142 26.8959 11.2799 25.8381 11.2799 24.5725C11.2799 23.3084 15.8142 22.2506 21.8892 21.9787V26.11C22.2861 26.1381 23.4236 26.2053 24.9955 26.2053C26.8814 26.2053 27.8267 26.1271 28.0033 26.1115V21.9818C34.0658 22.2521 38.5892 23.31 38.5892 24.5725C38.5892 25.8381 34.0658 26.8928 28.0033 27.1615V27.1615ZM28.0033 21.5521V17.8553H36.4627V12.2178H13.4299V17.8553H21.8892V21.5506C15.0142 21.8662 9.84393 23.2287 9.84393 24.86C9.84393 26.4912 15.0142 27.8521 21.8892 28.1693V40.0162H28.0033V28.1662C34.8674 27.8506 40.0252 26.4896 40.0252 24.86C40.0252 23.2303 34.8674 21.8693 28.0033 21.5521",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovedWithoutRed);
export default __webpack_public_path__ + "static/media/approved-without-red.e8cd59665c63ac63a1f57211ed411394.svg";
export { ForwardRef as ReactComponent };